import { AppFormItem, AppFormItemProps, AppTextArea } from 'components/atoms';
import { formFields } from 'consts/form/formFields';
import { max2000LengthRule } from 'consts/rules/textRules';
import { Rule } from 'antd/es/form';

export const DescriptionInputElement = ({
    maxLengthRule = max2000LengthRule,
    ...props
}: AppFormItemProps & { maxLengthRule?: Rule }) => (
    <AppFormItem label="Opis" name={formFields.description} rules={[maxLengthRule]} {...props}>
        <AppTextArea
            rows={6}
            autoComplete="off"
            placeholder="Podaj opis"
            disabled={props.disabled}
        />
    </AppFormItem>
);
